import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { HintField, InputField, LabelField, MyCheckbox, SelectField } from "components";
import InfoTooltip from "components/InfoTooltip";
import { MenuMultiCheckBox } from "components/MenuMultiCheckBox/MenuMultiCheckBox";
import { getDateFormat, getDateFormatForDatePicket } from "helper/dateFormat";
import { useSearch } from "hook";
import React, { useState } from 'react';
import { Col, Row } from "react-bootstrap";
import Select, { components } from "react-select";
import { DateRangePicker } from 'rsuite';
import { TagField } from '../TagField';
import { Label, StatementWrapper, TextAreaMessage } from './Theme';
import "./style.scss";

export const Statement = ({ formik, catagoryTypes, accountBillingTypes, DateRange, endDate, startDate, accountCategoryOptions, billingTypeOptions, ledgers, isLedgerLoading, accountTags, accountTagsLoading, contactTags, contactTagsLoading, accountTypeOptions }) => {
    const [search, setSearch] = useState("");
    const { searchAction } = useSearch({ action: setSearch });
    const [loading, setLoading] = useState(false);
    const [valueCheck, setCheckValue] = useState(false);
    const [date, setDate] = useState([]);
    const [allOpenCharges, setAllOpenCharges] = useState(false);
    const [excludeActivePayment, setExcludeActivePayment] = useState(false);
    const placeholderFormat = getDateFormat();
    const dateFormat = getDateFormatForDatePicket();

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <BottomArrowSvg label="Emoji" />
            </components.DropdownIndicator>
        );
    };
    const formatOptionLabel = ({ label, _id }) => {

        return (
            <div className="dropdown-container" key={_id}>
                <div className="icon-name-container d-flex align-items-center justify-content-start">
                    <div className="name-container" style={{ marginInlineStart: 10 }}>
                        <div>{formik.values.tax_statement?.filter?.account_type && label}</div>
                    </div>
                </div>
            </div>
        );
    };

    const selectControlStyles = {
        backgroundColor: "#FFFFFF",
        border: "1px solid #ebedf3",
        color: "#3F4254",
        transition:
            "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
        paddingTop: "6px",
        paddingBottom: "6px",
        cursor: "pointer",
    };
    const colourStyles = {
        control: (styles) => ({
            ...styles,
            ...selectControlStyles,
        }),
        menuList: (styles) => ({
            ...styles,
            maxHeight: "150px",
        }),
        menu: (styles) => ({
            ...styles,
            zIndex: 9999,
        }),
    };

    return (
        <StatementWrapper>
            <Row className="form-row sm-12 mb-4">
                <Col className="col-12 col-md-12">
                    <div className="form-group">
                        <InputField
                            mandatory
                            type="text"
                            {...{
                                formik,
                                title: "Batch Name",
                                name: `tax_statement.batchName`,
                                placeholder: "Batch Name",
                                checkValidation: true,
                                value: formik.values?.tax_statement?.batchName,
                            }}
                            style={{ backgroundColor: "#FFFFFF", border: "1px solid #ebedf3" }}

                        />
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div className="pt-1 account-type">
                        <LabelField title={"Account type"} />
                        <Select
                            {...{
                                formik,
                                name: `tax_statement.filter.account_type`,
                                mandatory: true,
                                checkValidation: false,
                            }}
                            isClearable={formik.values.tax_statement.filter?.account_type ?? false}
                            onInputChange={(text) => searchAction(text)}
                            classNamePrefix="react-select"
                            options={accountTypeOptions}
                            isLoading={loading}
                            styles={colourStyles}
                            onChange={(value) => {
                                if (!value) {
                                    formik.setFieldValue("tax_statement.filter.account_type", undefined)
                                    return;
                                }
                                formik.setFieldValue("tax_statement.filter.account_type", value.value);
                                formik.setFieldValue("account_sub_type", {
                                    id: "",
                                    name: "",
                                });
                            }}
                            value={accountTypeOptions.find((item) => item.value === formik.values.tax_statement.filter.account_type)}
                            components={{ DropdownIndicator }}

                        />
                        {formik.values.account_type === "" && valueCheck && (
                            <p className="text-red" style={{ marginBottom: "1em" }}>
                                Required!
                            </p>
                        )}

                    </div>
                </Col>
                <Col className="col-12 col-md-6"></Col>
                <Col className="col-12 col-md-6 mt-7">
                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", rowGap: "10px", gap: "1rem" }}>
                        {/* each checkbox stays on one line with its hint */}
                        <span style={{ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap" }}>
                        <MyCheckbox
                            title="All open charges"
                            checked={formik.values.tax_statement?.allOpenCharges}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                formik.setFieldValue('tax_statement.allOpenCharges', checked)
                                setAllOpenCharges(checked);
                                if (checked) {
                                    formik.setFieldValue('tax_statement.showZero', false);
                                } else {
                                    formik.setFieldValue('tax_statement.excludeActivePayment', false);
                                    setExcludeActivePayment(false);
                                }
                            }}
                        />
                        <InfoTooltip text="Include every currently open charge on the statement, instead of only charges within the selected date range." style={{ marginLeft: '4px', marginBottom: '8px' }} />
                        </span>
                        <span style={{ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap" }}>
                        <MyCheckbox
                            title="Exclude active payment plans"
                            checked={excludeActivePayment}
                            // disabled={!allOpenCharges}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setExcludeActivePayment(checked);
                                formik.setFieldValue('tax_statement.excludeActivePayment', checked);
                            }}
                        // titleStyles={!allOpenCharges ? {
                        //     opacity: 0.65,
                        //     pointerEvents: "none",
                        // } : {}}
                        />
                        <InfoTooltip text="Leave out charges that are already being paid off through an active recurring or installment payment plan." style={{ marginLeft: '4px', marginBottom: '8px' }} />
                        </span>
                    </div>
                </Col>
                <Col className="col-12 col-md-6 mt-7">
                    <div
                        className='batch_div'
                        style={{
                            minHeight: '120px', // Adjust as needed to match the DateRangePicker height
                            visibility: formik.values.tax_statement?.allOpenCharges ? 'hidden' : 'visible',
                            position: 'relative',
                            transition: 'visibility 0.2s',
                        }}
                    >
                        <LabelField title={"Date range"} mandatory={true} />
                        <div
                            style={{
                                width: '100%',
                                backgroundColor: ' #F3F6F9',
                                position: 'relative',
                            }}
                            className='date-range'
                        >
                            <DateRangePicker
                                format={dateFormat}
                                placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                                cleanable={true}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                style={{
                                    display: "inline-block",
                                    padding: '0',
                                    border: '0',
                                    width: "100%",
                                    color: 'black',
                                }}
                                size="lg"
                                value={date}
                                onChange={(update) => {
                                    DateRange(update);
                                    setDate(update)
                                }}
                            />
                            {startDate && endDate && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "24px",
                                        right: "15px",
                                        color: "#8080da",
                                        cursor: 'pointer',
                                        zIndex: "99999999",
                                    }}
                                    onClick={() => {
                                        DateRange([null, null]);
                                        setDate([]);
                                    }}
                                    preventOverflow={true}
                                >
                                    clear
                                </div>
                            )}
                        </div>
                    </div>
                </Col>

                <Col className="mt-7 col-12 col-md-6">
                    <div className="pt-1 account-subtype-field">
                        <LabelField title={"Account Category"} />
                        <Select
                            {...{
                                formik,
                                name: `account_sub_type`,
                                mandatory: true,
                                checkValidation: false,
                            }}
                            isClearable={formik.values.account_sub_type ?? false}
                            onInputChange={(text) => searchAction(text)}
                            classNamePrefix="react-select"
                            formatOptionLabel={formatOptionLabel}
                            options={accountCategoryOptions}
                            isLoading={loading}
                            styles={colourStyles}
                            onChange={(value) => {
                                if (!value) {
                                    formik.setFieldValue("account_sub_type", undefined)
                                    formik.setFieldValue(`tax_statement.filter.category`, undefined);
                                    return;
                                }

                                formik.setFieldValue(`account_sub_type`, {
                                    id: value.value,
                                    name: value.label,
                                });
                                formik.setFieldValue(`tax_statement.filter.category`, value.label);
                            }}
                            value={{
                                label: formik.values?.account_sub_type?.name,
                                value: formik.values?.account_sub_type?.id,
                            }}
                            components={{ DropdownIndicator }}
                        />
                        {!formik?.values?.["account_sub_type"]?.id &&
                            !formik?.values?.["billing_type"]?.name &&
                            formik?.touched?.["account_sub_type"] &&
                            formik?.errors?.["account_sub_type"] ? (
                            <HintField error={formik?.errors?.["account_sub_type"]?.value} />
                        ) : null}
                    </div>
                </Col>
                <Col className="mt-7 col-12 col-md-6">
                    <div className="pt-1 billing-type-field">
                        <LabelField title={"Billing type"} />

                        <Select
                            {...{
                                formik,
                                name: `billing_type`,
                                mandatory: true,
                                checkValidation: false,
                            }}
                            isClearable={formik.values.billing_type ?? false}
                            onInputChange={(text) => searchAction(text)}
                            classNamePrefix="react-select"
                            formatOptionLabel={formatOptionLabel}
                            options={billingTypeOptions}
                            isLoading={loading}
                            styles={colourStyles}
                            onChange={(value) => {
                                if (!value) {
                                    formik.setFieldValue("billing_type", undefined)
                                    formik.setFieldValue(`tax_statement.filter.billing_type`, undefined);
                                    return;
                                }
                                formik.setFieldValue(`billing_type`, {
                                    id: value.value,
                                    name: value.label,
                                });
                                formik.setFieldValue(`tax_statement.filter.billing_type`, value.label);
                            }}
                            value={{
                                label: formik.values?.billing_type?.name,
                                value: formik.values?.billing_type?.id,
                            }}
                            components={{ DropdownIndicator }}
                        />
                        {!formik?.values?.["billing_type"]?.id &&
                            !formik?.values?.["billing_type"]?.name &&
                            formik?.touched?.["billing_type"] &&
                            formik?.errors?.["billing_type"] ? (
                            <HintField error={formik?.errors?.["billing_type"]?.value} />
                        ) : null}
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div className="mt-7">
                        <LabelField title={"Exclude transactions from selected ledgers"} mandatory={false} />
                        <MenuMultiCheckBox
                            Items={ledgers}
                            formik={formik}
                            loading={isLedgerLoading}
                            isLedger={true}
                            withBorder={true}
                            field="all_ledger_sub_data"
                            styles={{
                                width: '100%',
                                '&& fieldset': {
                                    width: '100%',
                                },
                            }}
                        />
                    </div>
                </Col>
                <Col className="col-12 col-md-6"></Col>
                <Col className="col-12 col-md-6">
                    <Label>Account Tags</Label>
                    <Select
                        {...{
                            formik,
                            name: `accountTags`,
                            mandatory: true,
                            checkValidation: false,
                        }}
                        classNamePrefix="react-select"
                        options={accountTags}
                        valueKey="id"
                        labelKey="title"
                        isMulti
                        isLoading={accountTagsLoading}
                        styles={colourStyles}
                        onChange={(value) => {
                            formik.setFieldValue(`tax_statement.filter.accountTags`, value);
                        }}
                        value={formik.values?.tax_statement?.filter?.accountTags}
                        components={{ DropdownIndicator }}
                    />
                </Col>
                <Col className="col-12 col-md-6">
                    <Label>Contact Tags</Label>
                    <Select
                        {...{
                            formik,
                            name: `contactTags`,
                            mandatory: true,
                            checkValidation: false,
                        }}
                        classNamePrefix="react-select"
                        options={contactTags}
                        valueKey="id"
                        labelKey="title"
                        isMulti
                        isLoading={contactTagsLoading}
                        styles={colourStyles}
                        onChange={(value) => {
                            formik.setFieldValue(`tax_statement.filter.contactTags`, value);
                        }}
                        value={formik.values?.tax_statement?.filter?.contactTags}
                        components={{ DropdownIndicator }}
                    />
                </Col>
                <Col className="col-12 col-md-6">
                    <div
                        className="w-50"
                        style={{
                            marginTop: "2rem",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <MyCheckbox
                            title="Include close charges"
                            checked={formik.values.tax_statement?.showZero}
                            onChange={() => formik.setFieldValue('tax_statement.showZero', !formik.values.tax_statement?.showZero)}
                            disabled={formik.values.tax_statement?.allOpenCharges}
                            titleStyles={formik.values.tax_statement?.allOpenCharges ? {
                                opacity: 0.65,
                                pointerEvents: "none",
                            } : {}}
                        />
                        <InfoTooltip text="Also include charges that have already been fully paid off and closed, not just open ones." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div
                        className="w-50"
                        style={{
                            marginTop: "2rem",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <MyCheckbox
                            title="Delete existing document"
                            checked={formik.values.tax_statement?.deleteOldDocument}
                            onChange={() => formik.setFieldValue('tax_statement.deleteOldDocument', !formik.values.tax_statement?.deleteOldDocument)}
                        />
                        <InfoTooltip text="Replace any statement previously generated for the same accounts and date range, instead of creating a duplicate." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div
                        className="w-50"
                        style={{
                            marginTop: "2rem",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <MyCheckbox
                            title="Don’t create for account with no  transactions"
                            checked={formik.values.tax_statement?.deleteNoTransaction}
                            onChange={() => formik.setFieldValue('tax_statement.deleteNoTransaction', !formik.values.tax_statement?.deleteNoTransaction)}
                        />
                        <InfoTooltip text="Skip generating a statement for any account that has no matching transactions, instead of creating an empty document." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div
                        className="w-50"
                        style={{
                            marginTop: "2rem",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <MyCheckbox
                            title="Display credit on account balance"
                            checked={formik.values.tax_statement?.showBalance}
                            onChange={() => formik.setFieldValue('tax_statement.showBalance', !formik.values.tax_statement?.showBalance)}
                        />
                        <InfoTooltip text="Show the account's available credit on account balance on the statement, in addition to charges and payments." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                </Col>
                <Col className="col-12 col-md-12">
                    <div className="w-50" style={{ marginTop: "2rem" }}>
                        <MyCheckbox
                            title="Add note"
                            checked={formik.values.tax_statement?.addNote}
                            onChange={(e) => {
                                const { checked } = e.target;
                                formik.setFieldValue('tax_statement.addNote', checked);
                            }}
                        />
                    </div>
                    {formik.values.tax_statement?.addNote && (
                        <div style={{ marginTop: "2rem" }}>
                            <LabelField
                                title={"Note"}
                                mandatory={true}
                            />
                            <TextAreaMessage
                                aria-label="empty textarea"
                                minRows={12}
                                placeholder="Note"
                                value={formik.values.tax_statement?.note}
                                onChange={(e) => {
                                    formik.setFieldValue('tax_statement.note', e.target.value);
                                }}
                            />
                        </div>
                    )}
                </Col>
            </Row >
        </StatementWrapper>
    );
};
